import { render, staticRenderFns } from "./ElementTargetLevelTableColumn.vue?vue&type=template&id=05f47a66"
import script from "./ElementTargetLevelTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementTargetLevelTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports